import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { translator } from 'mage-i18n';
import { analytics, HorizontalWrapper } from 'moet-core';
import { ButtonSecondary } from '@klarna/bubble-ui';
import { ContainerTemplate } from '@/components';
import { getSetupData } from '@/selectors/data';
import { ANALYTICS_EVENTS } from './analyticsEvents';

const tPrefix = 'products-fe.containers.signup_products';
const weAreSorryPrefix = 'products-fe.containers.we_are_sorry';
const kustomPrefix = 'products-fe.containers.signup_products';

type WeAreSorryKustomProps = {
  t: TranslatorFunction;
  onBack: () => void;
  setupData?: {
    email: string;
    country: string;
    website: string;
    platform: string;
    annualRevenue: string;
  };
};

export const WeAreSorryKustom = ({
  t,
  onBack,
  setupData,
}: WeAreSorryKustomProps): React.JSX.Element => {
  useEffect(() => {
    const { email, country, website, annualRevenue, platform } = setupData || {};

    analytics.logEvent(ANALYTICS_EVENTS.weAreSorryKustom, {
      email,
      country,
      website,
      annualRevenue,
      platform,
    });
  }, []);

  return (
    <ContainerTemplate
      title={t(`${weAreSorryPrefix}.title_kustom`)}
      subtitle={t(`${kustomPrefix}.kustom.not_available`)}
    >
      <HorizontalWrapper display="inline-flex" alignItems="center" justifyContent="flex-start">
        <ButtonSecondary onClick={onBack}>{t(`${tPrefix}.buttons.back`)}</ButtonSecondary>
      </HorizontalWrapper>
    </ContainerTemplate>
  );
};

WeAreSorryKustom.propTypes = {
  t: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  setupData: PropTypes.shape({
    annualRevenue: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    platform: PropTypes.string.isRequired,
    website: PropTypes.string.isRequired,
  }),
};

export default connect(state => ({
  t: translator(state),
  setupData: getSetupData(state),
}))(WeAreSorryKustom);
